/**
 * กฎการแสดงปุ่ม "แก้ไข" ในหน้าจัดการโปรโมชัน ต้องตรงกับ guard ฝั่ง API (updatePromotion):
 * แก้ได้เฉพาะสถานะ WAITING/USING และยังไม่มีแถวใน order_promotions (usedCount จาก API)
 * ห้ามใช้ amountPromotion ("3/-") มาตัดสิน เพราะเป็น string สำหรับแสดงผล Number() ได้ NaN (MD-2610-1270)
 */
export const EDITABLE_PROMOTION_STATUSES = ['WAITING', 'USING'] as const

export type PromotionRowActionInput = {
    status?: string | null
    usedCount?: number | string | null
}

export function canEditPromotion(row: PromotionRowActionInput): boolean {
    if (!EDITABLE_PROMOTION_STATUSES.includes(row.status as any)) return false
    if (row.usedCount === undefined || row.usedCount === null || row.usedCount === '') return false
    const usedCount = Number(row.usedCount)
    return Number.isFinite(usedCount) && usedCount === 0
}
